// extracted by mini-css-extract-plugin
export default {"h":"style_h__VgsEQ","sh":"style_sh__A2DN0","p1":"style_p1__BA0mS","btn2":"style_btn2__NSzP-"};